import { maybeGetGoalUpdateAriFromUrlUpdateId } from '@townsquare/goal-update-card/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router/types';

import GoalEmbedQuery, {
	type GoalEmbedQuery as GoalEmbedQueryType,
} from '../components/Goal/__generated__/GoalEmbedQuery.graphql';

export const goalEmbedResource = createRelayResource<GoalEmbedQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const goalKey = routerContext.match.params.goalKey;
		const tabName = routerContext.match.params.tabName;

		const context = resourceContext as ResourceContext;

		const updateId = maybeGetGoalUpdateAriFromUrlUpdateId(routerContext.query.updateId, context.workspace?.cloudId);

		return {
			query: GoalEmbedQuery,
			variables: {
				key: goalKey || '',
				tabName: tabName || '',
				id: updateId || '',
				isSpecificUpdate: !!updateId,
			},
		};
	},
});
